import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
interface Props {
  containerRef: React.Ref<HTMLDivElement>;
  visible: boolean;
}
export function useFocusTrapKeyHandler(t0) {
  const $ = _c(4);
  const {
    containerRef,
    visible
  } = t0;
  let t1;
  let t2;
  if ($[0] !== containerRef || $[1] !== visible) {
    t1 = () => {
      if (!visible) {
        return _temp;
      }
      const focusableElements = containerRef && "current" in containerRef ? containerRef.current?.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"]") : undefined;
      const getLastVisibleFocusableElement = function getLastVisibleFocusableElement() {
        if (!focusableElements) {
          return;
        }
        for (let i = focusableElements.length - 1; i >= 0; i = i - 1, i) {
          const element = focusableElements[i];
          if (element.offsetParent !== null) {
            return element;
          }
        }
      };
      const firstElement = focusableElements?.[0];
      const focusTrapHandler = e => {
        if (e.key === "Tab") {
          const lastElement = getLastVisibleFocusableElement();
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement?.focus();
          } else {
            if (!e.shiftKey && document.activeElement === lastElement) {
              e.preventDefault();
              firstElement?.focus();
            }
          }
          e.stopImmediatePropagation();
        }
      };
      document.body.addEventListener("keydown", focusTrapHandler);
      if (containerRef && "current" in containerRef) {
        containerRef.current?.focus();
      }
      return () => {
        document.body.removeEventListener("keydown", focusTrapHandler);
      };
    };
    t2 = [containerRef, visible];
    $[0] = containerRef;
    $[1] = visible;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
}
function _temp() {
  return null;
}